export enum Routes {
  Services = '/',
  Profile = '/profile',
  UpdateProfile = '/update-profile',
  Stores = '/stores',
  ReservationForm = '/reservation',
  ReservationSummary = '/summary',
  ThanksPage = '/thanks',
}
